/* eslint-disable */
import TimeInput from './TimeInput';

export default TimeInput;
